import { Component, OnInit , Input ,Output,EventEmitter } from '@angular/core';

@Component({
  selector: 'app-chekbox',
  templateUrl: './chekbox.component.html',
  styleUrls: ['./chekbox.component.scss'],
})
export class ChekboxComponent implements OnInit {

  private quest : any;

  @Input()
  set quest1(quest1: any) {
    this.quest = (quest1) || '<no quest set>';
  }

  get quest1(): any { return this.quest; }

  @Output() eventchild = new EventEmitter<string>();



  tabQuest : any;
  nbquest : number;
  posiquest : number = -1 ;
  tabPosQuest = [];
  tabComponents = [];

  radiovalue : number;


  constructor() { }

  ngOnInit() {}

  ngOnChanges() {
    
    //alert(this.url); 

       
        this.tabQuest = this.quest;

        //alert(this.tabQuest[1][1]["text"]);
        
       
        this.nbquest = Object.keys(this.tabQuest).length;

        


        let tab1 = [];
        //for(let i = 1 ; i<this.nbquest;i++) {
        for (let i = 0; i < this.nbquest; i++) {
          tab1.push(i);
        }

        let hasard: number;
        //this.tabPosQuest.push(0);
        //for(let i = 0 ; i<this.nbquest-1;i++) {
        for (let i = 0; i < this.nbquest; i++) {
          hasard = Math.floor(Math.random() * tab1.length);
          //hasard = i;
          this.tabPosQuest.push(tab1[hasard]);
          //this.tabnumquest.push(i);

          tab1.splice(hasard, 1);
        }

        //alert(this.tabPosQuest);
        
        this.changerquest();

  }
  
  changerquest() {
    //this.posiquest++;

    this.tabComponents = this.getTabQuest();

    // alert(this.tabComponents);
  }

  //retourne la page 
  getTabQuest() {
    
    //alert(this.posiquest);
    //alert(this.tabQuest[0]);
    //let lgTab = this.tabQuest[this.posiquest].length;
    
    let tabArray = []; 
    //let tab1 : any; 
    //alert(JSON.stringify(tabPage));

    let sol : boolean;
    let rep : boolean;

    
    

    for (let i =0 ; i< this.nbquest;i++) {
        rep = false;
        sol = false;
        if(this.tabQuest[this.tabPosQuest[i]].sol) sol=true;
        if(this.tabQuest[this.tabPosQuest[i]].rep) rep=true;
        
        tabArray.push({
        id : this.tabPosQuest[i],
        label : this.tabQuest[this.tabPosQuest[i]].label,
        sol : sol,
        rep : rep
      
        });

        //alert(this.tabPosQuest[i] +" " + tabArray[i].rep + " " +  tabArray[i].sol );
 
      
    }//fin for

   // alert(tabArray); 
    return tabArray; 
    // alert(this.route.snapshot.paramMap.get("idp"));

  }

  changeCheckbox(numero: number) {
    
   //alert(numero +" " + this.tabComponents[numero].rep + " " +  this.tabComponents[numero].sol );
   
   
    this.tabComponents[this.tabPosQuest[numero]].rep = !this.tabComponents[this.tabPosQuest[numero]].rep ;

  //alert(numero +" " + this.tabComponents[numero].rep + " " +  this.tabComponents[numero].sol );
   
  
   // alert(this.tabComponents[numero].rep);
   this.tabQuest[numero].rep = this.tabComponents[this.tabPosQuest[numero]].rep;
    
   let bonreponse : boolean = true;
   let i = 0;
   while (i<this.nbquest && bonreponse) {
    //alert(this.tabComponents[i].rep +' '+ this.tabComponents[i].sol);
    
    
    if(this.tabComponents[i].rep != this.tabComponents[i].sol) bonreponse=false;
     i++;
   }

   //alert(bonreponse);

    

    this.tabQuest[0].res = bonreponse; 
    
    
     this.quest = this.tabQuest;
    //alert(this.tabComponents[this.radiovalue].sol);
    
      
    this.eventchild.emit("btvalider");
  

  }//fin radiogroup


}
